import { DEFAULT_LAYOUT } from '../base';
import { type AppRouteRecordRaw } from '../types';
import { IconHome } from '@arco-design/web-vue/es/icon';

const routes: AppRouteRecordRaw = {
  path: '/welcome',
  redirect: '/welcome/index',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '首页',
    icon: IconHome,
    hideChildrenInMenu: true,
    order: 0,
    autoSetTitle: false,
  },
  children: [
    {
      path: 'index',
      component: () => import('@/views/welcome/index.vue'),
      meta: {
      },
    },
  ],
};

export default routes;
